import { Component, OnInit, Injector } from '@angular/core';
import {
  UntypedFormGroup,
  UntypedFormControl,
  Validators,
} from '@angular/forms';
import { SecondPageEditBase } from 'vnpost-shared';
import { ProductService } from '../../services/product.service';
import { CategoryService } from '../../services/category.service';

@Component({
  selector: 'app-edit-product',
  templateUrl: './edit-product.component.html',
  styleUrls: ['./edit-product.component.css'],
})
export class EditProductComponent extends SecondPageEditBase implements OnInit {
  listStatus: { label: string; value: number }[] = [
    { label: 'Đang áp dụng', value: 1 },
    { label: 'Ngừng áp dụng', value: 0 },
  ];
  listCategory: { label: string; value: string }[] = [];
  isDisable: boolean;

  constructor(
    protected _productService: ProductService,
    protected _categoryService: CategoryService,
    protected _injector: Injector
  ) {
    super(_productService, _injector);
    this.formGroup = new UntypedFormGroup({
      code: new UntypedFormControl('', [Validators.required]),
      name: new UntypedFormControl('', [Validators.required]),
      categoryId: new UntypedFormControl('', [Validators.required]),
      status: new UntypedFormControl(''),
    });
  }

  ngOnInit() {}

  getListCategory() {
    const model = {
      status: 1
    };
    this._categoryService.getListCategory(model).then(
      (res) => {
        this.listCategory = res?.data.map((x) => ({
          label: `${x.code} - ${x.name}`,
          value: x.id,
        }));
      },
      (err) => {
        this.listCategory = [];
      }
    );
  }

  onShowPopup(model: any) {
    this.isDisable = model.isDisable;
    if (this.listCategory.length == 0) {
      this.getListCategory();
    }
    this.validationSummary.resetErrorMessages();
    this.resetForm();

    if (model.id > 0) {
      this._productService.getProductDetail(model.id).then(
        (res) => {
          this.itemDetail = res.data;
        },
        (error) => {
          if (error?.error?.message) 
            this._notifierService.showError(error?.error?.message);
          else this._notifierService.showWarning(
            this._translateService.instant('MESSAGE.NOT_FOUND_ERROR')
          );
        }
      );
    }
  }

  async save() {
    this.submitting = true;

    if (this.formGroup.invalid) {
      this.submitting = false;
      this.validationSummary.showValidationSummary();
      return;
    }

    this.onUpdate();
  }

  onUpdate() {
    this._productService.update(this.itemDetail.id, this.itemDetail).then(
      (response) => {
        this.closePopupMethod(true);
        this._notifierService.showUpdateDataSuccess();
        this.onAfterSave();
        this.submitting = false;
      },
      (error) => {
        if (error?.error?.message) 
          this._notifierService.showError(error?.error?.message);
        else this._notifierService.showUpdateDataFailed();
        this.submitting = false;
      }
    );
  }
}
